import type { OpenEngagements } from "@/lib/reporting.api";
import { formatXaf } from "../creancesEngagements.formatters";
import { MetricTile } from "./MetricTile";

export function OpenEngagementsSection({ engagements }: { engagements: OpenEngagements }) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">Engagements non clôturés</p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">
        Affaires pas encore commises - indépendant de la période sélectionnée.
      </p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <MetricTile
          label="Factures en brouillon"
          value={engagements.draftInvoiceCount}
          detail={`${formatXaf(engagements.draftInvoiceValue)} potentiel`}
        />
        <MetricTile
          label="Proformas ouverts"
          value={engagements.openProformaCount}
          detail={`${formatXaf(engagements.openProformaValue)} potentiel`}
        />
      </div>
    </div>
  );
}
